<div class="flex gap-2 items-center justify-center flex-wrap">
  <app-save-listing [label]="true" [listing]="listing()" />

  @if (isApp()) {
    <button
      class="rounded-md px-2.5 py-1.5 text-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/30 dark:focus-visible:outline-white/30 flex flex-row gap-2 h-10 items-center hover:bg-gray-50 dark:hover:bg-gray-900/20 cursor-pointer"
      (click)="directionsPostMessage()"
    >
      <svg viewBox="0 -960 960 960" class="fill-gray-900 dark:fill-gray-100 h-4 w-4">
        <path
          d="M120-160v-640l760 320-760 320Zm80-120 474-200-474-200v140l240 60-240 60v140Zm0 0v-400 400Z"
        />
      </svg>

      Directions
    </button>

    <div class="md:hidden basis-full h-0"></div>
  }

  <a href="tel:+13527536655">
    <button
      class="rounded-md px-2.5 py-1.5 text-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/30 dark:focus-visible:outline-white/30 flex flex-row gap-2 h-10 items-center hover:bg-gray-50 dark:hover:bg-gray-900/20 cursor-pointer"
    >
      <svg viewBox="0 -960 960 960" class="fill-gray-900 dark:fill-gray-100 h-4 w-4">
        <path
          d="M162-120q-18 0-30-12t-12-30v-162q0-13 9-23.5t23-14.5l138-28q14-2 28.5 2.5T342-374l94 94q38-22 72-48.5t65-57.5q33-32 60.5-66.5T681-524l-97-98q-8-8-11-19t-1-27l26-140q2-13 13-22.5t25-9.5h162q18 0 30 12t12 30q0 125-54.5 247T631-329Q531-229 409-174.5T162-120Z"
        />
      </svg>

      @if (isApp()) {
        Call
      } @else {
        <span class="hidden lg:inline-block text-brand-secondary">352-753-6655</span>
        <span class="lg:hidden">Call</span>
      }
    </button>
  </a>

  <button
    class="rounded-md px-2.5 py-1.5 text-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/30 dark:focus-visible:outline-white/30 flex flex-row gap-2 h-10 items-center hover:bg-gray-50 dark:hover:bg-gray-900/20 cursor-pointer"
    (click)="openShareModal()"
  >
    <svg viewBox="0 -960 960 960" class="fill-gray-900 dark:fill-gray-100 h-4 w-4">
      <path
        d="M672.22-100q-44.91 0-76.26-31.41-31.34-31.41-31.34-76.28 0-6 4.15-29.16L284.31-404.31q-14.46 15-34.36 23.5t-42.64 8.5q-44.71 0-76.01-31.54Q100-435.39 100-480q0-44.61 31.3-76.15 31.3-31.54 76.01-31.54 22.74 0 42.64 8.5 19.9 8.5 34.36 23.5l284.46-167.08q-2.38-7.38-3.27-14.46-.88-7.08-.88-15.08 0-44.87 31.43-76.28Q627.49-860 672.4-860t76.25 31.44Q780-797.13 780-752.22q0 44.91-31.41 76.26-31.41 31.34-76.28 31.34-22.85 0-42.5-8.69Q610.15-662 595.69-677L311.23-509.54q2.38 7.39 3.27 14.46.88 7.08.88 15.08t-.88 15.08q-.89 7.07-3.27 14.46L595.69-283q14.46-15 34.12-23.69 19.65-8.69 42.5-8.69 44.87 0 76.28 31.43Q780-252.51 780-207.6t-31.44 76.25Q717.13-100 672.22-100Z"
      />
    </svg>

    Share
  </button>
</div>
